import { PlethoraLib } from "plethora-lib"
import { SimulationState } from "plethora-lib/API/api.definitions"

export function bindEventHandlers() {
  PlethoraLib.getInstance().onSimulationStateChange((state: SimulationState) => {
    console.log(`PlethoraLib.onSimulationStateChange(${state})`)

    if (state === "INIT") {
      // handle entrance to init process
      gameInstance.SendMessage("GridManager", "SetSimulationState","INIT")
    } else if (state === "READY") {
      // handle end of init
      // request start automatically after init:
      gameInstance.SendMessage("GridManager", "SetSimulationState","READY")
      PlethoraLib.getInstance().requestStart()
    } else if (state === "PAUSED") {
      // handle pausing
      gameInstance.SendMessage("GridManager", "SetSimulationState","PAUSED")
    } else if (state === "RUNNING") {  
      // handle starting & resuming
      gameInstance.SendMessage("GridManager", "SetSimulationState","RUNNING")
    } else if (state === "RESET") {
      // handle transition to RESET
      // this function is called *before* calling onDestory() on every entity,
      // and *before* calling onReset()
      // this function can be used to show a loading screen, etc.
      // important! don't use this function to handle removal of entities
      // use onReset() instead.
      gameInstance.SendMessage("GridManager", "SetSimulationState","RESET")
      //gameInstance.SendMessage("GridManager", "ResetSimulation","")
    }
  })

  PlethoraLib.getInstance().onReset(() => {
    // this function will be called *after* calling onDestory() on every entity
    // the entities still exist in the model at this point and will be removed
    // only after this function finish executing
    gameInstance.SendMessage("GridManager", "ResetSimulation","")
  })
  
  PlethoraLib.getInstance().onSetLanguage((langCode: string) => {
    // this function will be called on startup or whenever the website language is changed
    console.log(`PlethoraLib.onSetLanguage(langCode = '${langCode}')`)
  })
}
